export const WIRE_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME = 'wire-template-workflow-container';
